var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-prime--arrow-up-right-and-arrow-down-left-from-center';
                    var viewUrl = 'gfx/sprite.svg#view-icon-prime--arrow-up-right-and-arrow-down-left-from-center';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };